import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface QuadruplePanelInterface extends ConfigurationProps {}
const QuadruplePanel: React.FC<QuadruplePanelInterface> = ({
  materials,
  position,
  scale,
}: QuadruplePanelInterface) => {
  const panelPosition0 = new Vector3(-0.459, -0.004, 0);
  const panelPosition1 = new Vector3(0.459, -0.004, 0);
  const panelPosition2 = new Vector3(1.375, -0.004, 0);
  const panelPosition3 = new Vector3(2.29, -0.004, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([
        panelPosition0,
        panelPosition1,
        panelPosition2,
        panelPosition3,
      ])
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Paneel materials={materials} position={positions[0]} index={0} />
      <Paneel materials={materials} position={positions[1]} index={1} />
      <Paneel materials={materials} position={positions[2]} index={2} />
      <Paneel materials={materials} position={positions[3]} index={3} />
    </group>
  );
};

export default QuadruplePanel;
